import { render, staticRenderFns } from "./GamTaskModal.vue?vue&type=template&id=c3279ca0&scoped=true&"
import script from "./GamTaskModal.vue?vue&type=script&lang=js&"
export * from "./GamTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./GamTaskModal.vue?vue&type=style&index=0&id=c3279ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3279ca0",
  null
  
)

export default component.exports